<template>
  <div id="app"> 
    <!-- <QQserver></QQserver>  -->
    <router-view/>
    <myfooter></myfooter>
  </div>
</template>

<script>
import QQserver from "./components/common/QQserver.vue";
import myfooter from "./components/common/footer.vue";
export default {
  name: 'App',
  components: {
    QQserver,
    myfooter
  },
}
</script>

<style lang="less">
@import url("./assets/css/style.less");
#app {
  position: relative;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-width: 1300px;
}
a:hover {
  color: @indexTheme;
}
@font-face {
  font-family: 'iconfont';
  src: url('./assets/fonts/iconfont.ttf?t=1624069802142') format('truetype');
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
}

</style>



// WEBPACK FOOTER //
// src/App.vue